// Services
import CStorage from './CStorage';
import CIndexedDB from './CIndexedDB';
import CSessaoAtual from '../api/security/CSessaoAtual';
import CServidorTekMonitor from '../tek-monitor/CServidorTekMonitor';
import CPreferenciasSecurity from './preferencias/security/CPreferenciasSecurity';
import CPreferenciasDataSet from './preferencias/indicadores/CPreferenciasDataSet';
import CPreferenciaCredencialAcessoERP from './preferencias/security/classes/CPreferenciaCredencialAcessoERP';
import CPreferenciaCredencialAcessoAPI from './preferencias/security/classes/CPreferenciaCredencialAcessoAPI';

const cCHAVE_HOST_LOCAL: string = 'HostLocal';
const cCHAVE_PORTA_LOCAL: string = 'PortaLocal';
export const cCHAVE_IDENTIFICADOR_ABA = 'IdentificadorAbaAtual';

export default class CSessao extends CStorage {
  private static _inicializado = false;
  private static _indexDB: IDBDatabase;
  private static _promessaInicializacao: Promise<void> | null = null;
  static _securityIndexDB: CPreferenciasSecurity | null = null;
  static preferenciasDataSetIndexDB: CPreferenciasDataSet | null = null;

  public static sessaoAtual: CSessaoAtual = new CSessaoAtual();
  public static servidorAplicacao: CServidorTekMonitor = new CServidorTekMonitor();
  public static credencialAPI: CPreferenciaCredencialAcessoAPI = new CPreferenciaCredencialAcessoAPI();
  public static credencialERP: CPreferenciaCredencialAcessoERP = new CPreferenciaCredencialAcessoERP();

  public static get indexDB() {
    if (!this._indexDB) {
      throw new Error('IndexedDB não inicializado. Certifique-se de chamar CSessao.inicializar() antes de acessar.');
    }
    return this._indexDB;
  }

  public static get isInicializado() {
    return this._inicializado;
  }

  public static get hostLocal(): string {
    return CSessao.getItem(cCHAVE_HOST_LOCAL, '');
  }

  public static set hostLocal(pValor: string) {
    CSessao.setItem(cCHAVE_HOST_LOCAL, pValor);
  }

  public static get portaLocal(): string {
    return CSessao.getItem(cCHAVE_PORTA_LOCAL, '');
  }

  public static set portaLocal(pValor: string) {
    CSessao.setItem(cCHAVE_PORTA_LOCAL, pValor);
  }

  public static definirPreferenciasDataSet(pStoreName: string) {
    this.preferenciasDataSetIndexDB = new CPreferenciasDataSet(this.indexDB, pStoreName);
  }

  public static async inicializar(pStoreNames: string[]): Promise<void> {
    if (this._inicializado) return;

    // Armazena a promessa para que múltiplos chamados esperem a mesma execução
    if (!this._promessaInicializacao) {
      this._promessaInicializacao = (async () => {
        this._indexDB = await CIndexedDB.inicializar(pStoreNames);
        this._securityIndexDB = new CPreferenciasSecurity(this._indexDB);

        await this._securityIndexDB.sincronizarDadosAbaDuplicada();

        this.sessaoAtual = await this._securityIndexDB.recuperarSessaoAtual();
        this.credencialERP = await this._securityIndexDB.recuperarCredencialERP();
        this.credencialAPI = await this._securityIndexDB.recuperarCredencialAPI();
        this.servidorAplicacao = await this._securityIndexDB.recuperarServidorAplicacao();

        this._inicializado = true;

        // Roda sem 'await' para não atrasar a entrada do usuário no sistema
        this._securityIndexDB.realizarLimpezaSessoesInativas(7).catch((err) => {
          console.error('[GC Error]', err);
        });
      })();
    }
    return this._promessaInicializacao;
  }

  static async realizarLimpezaSessoesInativas(pHorasExpiracao: number) {
    return await this._securityIndexDB?.realizarLimpezaSessoesInativas(pHorasExpiracao);
  }

  public static async definirSessaoAtual(pDados: CSessaoAtual) {
    this.sessaoAtual = pDados;
    return await this._securityIndexDB?.armazenarSessaoAtual(pDados);
  }

  public static async definirCredencialERP(pCredencial: CPreferenciaCredencialAcessoERP) {
    this.credencialERP = pCredencial;
    return await this._securityIndexDB?.armazenarCredencialERP(pCredencial);
  }

  public static async definirCredencialAPI(pCredencial: CPreferenciaCredencialAcessoAPI) {
    this.credencialAPI = pCredencial;
    return await this._securityIndexDB?.armazenarCredencialAPI(pCredencial);
  }

  public static async definirServidorAplicacao(pServidor: CServidorTekMonitor) {
    this.servidorAplicacao = pServidor;
    return await this._securityIndexDB?.armazenarServidorAplicacao(pServidor);
  }

  public static async logout() {
    this.sessaoAtual = new CSessaoAtual();
    this.servidorAplicacao = new CServidorTekMonitor();
    this.credencialAPI = new CPreferenciaCredencialAcessoAPI();
    this.credencialERP = new CPreferenciaCredencialAcessoERP();

    await this._securityIndexDB?.limparSessaoAba();
  }

  // -------------------------------------
  // Clear
  // -------------------------------------
  public static clear() {
    CSessao.handle.clear();
  }
}

CSessao.handle = window.sessionStorage;
